import jQuery from 'jquery';
import React from 'react';
import ReactDOM from "react-dom";
import {SearchWidget} from "./search-autocomplete/search-widget";

export default function searchAutocomplete(mountPoint) {
	// The mount-point is a input[type="text]-field.
	const field = jQuery(mountPoint);
	const attributes = {};

	if(field.length > 0) {
		for(const attr of field.get(0).attributes) {
			const name = attr.nodeName.toLowerCase();
			if(name !== 'class' && !name.match(/^data-/)) {
				attributes[name] = attr.nodeValue;
			}
		}
	}

	attributes['autocomplete'] = 'off';

	const lang = field.find('input[data-endpoint]').data('lang') || 'de';
	const endpoint = field.find('input[data-endpoint]').data('endpoint') || null;

	ReactDOM.render(<SearchWidget attributes={attributes} lang={lang} endpoint={endpoint} />, mountPoint);
};
